import React from 'react';
import styled from 'styled-components';
import Agriculture from '../../components/Agriculture/Agriculture';
import Target from '../../assets/target.png';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';


const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:300px;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

    @media (max-width: 768px) {
    height: 60vh;

  }
`;



class CardAgriculture extends React.Component {
  render () {
   return (

<Container>
    
    <Viz>
      <Agriculture />

    </Viz>

   <ReusableDetailCard
   trend= {Target}
   metricsm="Threatened"
   diagnosis="The imperative to feed a growing global population and drive industrial development is increasing competition for scarce water resources. Global food calorie production is projected to increase 70 percent between 2006 and 2050 (Resource Watch). "
   prediction="More floods and severe droughts are predicted. Changes in water availability will impact health and food security and have already proven to trigger refugee dynamics and political instability (United Nations)."
   significanceorthreat="SIGNIFICANCE"
   confidence="CONFICENCE LV: 95%"
   />
</Container>

  );
 }
}

export default CardAgriculture;
